<template>
  <svg viewBox="0 0 28 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g transform="translate(-76.000000, -522.000000)">
      <g transform="translate(63.000000, 505.000000)">
        <path d="
          M17.4248951,27.8158803 C17.4248951,24.0841723 20.7226148,21.0591378 24.7904684,
          21.0591378 C28.85843,
          21.0591378 32.1561497,24.0841723 32.1561497,27.8158803 C32.1561497,31.5475884 28.85843,
          34.5726229 24.7904684,34.5726229 C20.7226148,34.5726229 17.4248951,31.5475884 17.4248951,
          27.8158803 L17.4248951,27.8158803 Z M41,39.6205885 L34.6294125,33.7765872 C35.8623179,
          32.067414 36.5809368,30.0187244 36.5809368,27.8158803 C36.5809368,21.8423933 31.3022093,
          17 24.7904684,17 C18.2788355,17 13,21.8423933 13,27.8158803 C13,33.7892683 18.2788355,
          38.6317606 24.7904684,38.6317606 C27.0140397,38.6317606 29.0935417,38.0667586 30.8684893,
          37.085262 L37.3162954,43 L41,39.6205885 Z
        "></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SearchIcon',
};
</script>
